import React, { useState } from "react";
import NVLineChartWithLegends from "common/graphs/NVLineChart";
import styled from "styled-components";
import SelectInputWithIcon from "common/SelectInputWithIcon";
import { metricChoices as defaultMetricChoices } from "common/constants";

const ChartContainer = styled.div`
  height: 7.5cm;
  .graph {
    height: calc(100% - 20px);
    margin: 5px 0px 0px 0px;

    .legends{
      ul{
        margin-bottom: 0px !important;
      }
    }
  } 
  h4 {
    font-size: var(--chart-title-font-size, 18px) !important;
  }
  .border {
    position: absolute;
    background-color: transparent;

    &.top {
      width: 100%;
      height: 45px;
      top: -45px;
      left: 0;
    }

    &.right {
      width: 40px;
      height: 100%;
      top: 0;
      right: 0;
    }

    &.bottom {
      width: 100%;
      height: 30px;
      bottom: 0;
      left: 0;
    }

    &.left {
      width: 60px;
      height: 100%;
      top: 0;
      left: 0;
    }
  }
`;

const CenteredMessage = styled.div`
  height: calc(100% - 20px);
  margin: 5px 0px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  h4 {
    margin: 0;
  }
  & > div {
    margin-bottom: 0px;
    height: 15px;
  }
`;

const SelectWrapper = styled.div`
  width: 180px;
  margin-bottom: 15px;
  margin-right: 20px;
`;

const Loading = () => <CenteredMessage>Loading...</CenteredMessage>;

export const Chart = ({
  interactionData,
  setInteractionData,
  title,
  fields,
  items,
  yAxisUnits,
  yTooltipFormat,
  loading = false,
  type,
  metricCluster,
  setMetricCluster,
  metricChoices = defaultMetricChoices
}) => {
  const [metric, setMetric] = useState("all");
  const newFields =
    type === "latency"
      ? fields.filter((field) => metric === "all" || field.name === metric)
      : fields;

  const metricChoicesCluster = metricChoices.filter(({ value }) => value !== "all");

  return (
    <ChartContainer key={title}>
      <Header>
        <h4 className="title">{title}</h4>
        {type === "latency" ? (
          <SelectWrapper>
            <SelectInputWithIcon
              title="Metric"
              name="Metric"
              icon="insert_chart"
              selected={metric}
              onChange={({ target }) => setMetric(target.value)}
              options={metricChoices}
            />
          </SelectWrapper>
        ) : null}
        {type === "latency-cluster" ? (
          <SelectWrapper>
            <SelectInputWithIcon
              title="Metric"
              name="Metric"
              icon="insert_chart"
              selected={metricCluster}
              onChange={({ target }) => setMetricCluster(target.value)}
              options={metricChoicesCluster}
            />
          </SelectWrapper>
        ) : null}
      </Header>
      {loading === true && <Loading />}
      {!loading && (
        <NVLineChartWithLegends
          key={`chart-${type}-${metric}`}
          items={items}
          xField="time"
          className="graph"
          yAxisUnits={yAxisUnits}
          xAxisFormat={d3.timeFormat("%m/%d %H:%M")}
          yTooltipFormat={yTooltipFormat}
          fields={newFields}
          yAxisTopGap={0.05}
          fixedYRange={[0, 1]}
          onHighlight={(event) => {
            setInteractionData(event);
          }}
          highlight={interactionData}
          tooltipEnabled={true}
          reactTooltipEnabled={false}
        />
      )}
      {!loading ? (
        <>
          <div
            className="border top"
            onMouseEnter={() => setInteractionData(null)}
            onMouseLeave={() => setInteractionData(null)}
          ></div>
          <div
            className="border right"
            onMouseEnter={() => setInteractionData(null)}
            onMouseLeave={() => setInteractionData(null)}
          ></div>
          <div
            className="border bottom"
            onMouseEnter={() => setInteractionData(null)}
            onMouseLeave={() => setInteractionData(null)}
          ></div>
          <div
            className="border left"
            onMouseEnter={() => setInteractionData(null)}
            onMouseLeave={() => setInteractionData(null)}
          ></div>
        </>
      ) : null}
    </ChartContainer>
  );
};
